import { render } from "./header-comp.vue?vue&type=template&id=6b425f1a&scoped=true"
import script from "./header-comp.vue?vue&type=script&lang=js"
export * from "./header-comp.vue?vue&type=script&lang=js"

import "./header-comp.vue?vue&type=style&index=0&id=6b425f1a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b425f1a"]])

export default __exports__